import { render, staticRenderFns } from "./CustomerSegment.vue?vue&type=template&id=d7841bba&scoped=true&"
import script from "./CustomerSegment.vue?vue&type=script&lang=js&"
export * from "./CustomerSegment.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSegment.vue?vue&type=style&index=0&id=d7841bba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7841bba",
  null
  
)

export default component.exports